import { renderless, api } from "@opentiny/vue-renderless/dropdown/vue";
import { defineComponent, $prefix, directive, setup as _setup, h } from "@opentiny/vue-common";
import Button from "@opentiny/vue-button";
import ButtonGroup from "@opentiny/vue-button-group";
import Clickoutside from "@opentiny/vue-renderless/common/deps/clickoutside";
import DropdownMenu from "@opentiny/vue-dropdown-menu";
import { iconDownWard, iconDeltaDown } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  name: $prefix + "Dropdown",
  componentName: "TinyDropdown",
  components: {
    TinyButton: Button,
    TinyButtonGroup: ButtonGroup,
    TinyDropdownMenu: DropdownMenu,
    IconDownWard: iconDownWard()
  },
  directives: directive({
    Clickoutside
  }),
  props: {
    type: String,
    trigger: {
      type: String,
      default: "hover"
    },
    size: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    splitButton: Boolean,
    showTimeout: {
      type: Number,
      default: 250
    },
    hideTimeout: {
      type: Number,
      default: 150
    },
    hideOnClick: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    border: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    menuOptions: {
      type: Object,
      default: function _default() {
        return {
          options: [],
          textField: "label",
          popperClass: "",
          placement: "bottom-end"
        };
      }
    },
    title: {
      type: String,
      default: "下拉菜单"
    },
    inheritWidth: {
      type: Boolean,
      default: false
    }
  },
  emits: ["visible-change", "item-click", "button-click", "menu-item-click", "handle-click"],
  setup: function setup(props, context) {
    return _setup({
      props,
      context,
      renderless,
      api,
      mono: true,
      h
    });
  },
  render: function render() {
    var _state$designConfig, _state$designConfig$i, _state$designConfig2, _state$designConfig2$;
    var h2 = arguments[0];
    var splitButton = this.splitButton, type = this.type, disabled = this.disabled, handleMainButtonClick = this.handleMainButtonClick, menuOptions = this.menuOptions, title = this.title;
    var slots = this.slots, size = this.size, state = this.state, border = this.border, showIcon = this.showIcon, round = this.round, clickOutside = this.clickOutside;
    var params = {
      visible: state.visible
    };
    var triggerElm = null;
    var triggerClass = "tiny-dropdown__trigger tiny-dropdown-trigger";
    var visibleClass = state.visible ? "tiny-dropdown--visible tiny-dropdown-visible" : "";
    var IconDown = ((_state$designConfig = state.designConfig) == null ? void 0 : (_state$designConfig$i = _state$designConfig.icons) == null ? void 0 : _state$designConfig$i.dropdownIcon) || iconDeltaDown();
    var ButtonIconDown = ((_state$designConfig2 = state.designConfig) == null ? void 0 : (_state$designConfig2$ = _state$designConfig2.icons) == null ? void 0 : _state$designConfig2$.dropdownIcon) || iconDownWard();
    var defaultSlot = slots.default && slots.default(params);
    if (splitButton) {
      triggerElm = h2("tiny-button-group", [h2("tiny-button", {
        "attrs": {
          "type": type,
          "size": size,
          "disabled": disabled
        },
        "on": {
          "click": handleMainButtonClick
        },
        "class": "tiny-dropdown__title-button"
      }, [defaultSlot]), h2("tiny-button", {
        "ref": "trigger",
        "attrs": {
          "type": type,
          "size": size,
          "disabled": disabled,
          "reset-time": 0
        },
        "class": "tiny-dropdown__caret-button " + triggerClass
      }, [h2(ButtonIconDown, {
        "class": visibleClass
      })])]);
    } else {
      var _defaultSlot$;
      var suffixSlot = slots["suffix-icon"] && slots["suffix-icon"]();
      var vnodeData = defaultSlot && ((_defaultSlot$ = defaultSlot[0]) == null ? void 0 : _defaultSlot$.data) || {};
      var _vnodeData$attrs = vnodeData.attrs, attrs = _vnodeData$attrs === void 0 ? {} : _vnodeData$attrs;
      if (disabled && !attrs.disabled) {
        attrs.disabled = true;
        vnodeData.attrs = attrs;
      }
      var suffixInner = showIcon ? h2("span", {
        "class": "tiny-dropdown__suffix-inner"
      }, [suffixSlot || h2(IconDown, {
        "class": visibleClass
      })]) : "";
      var defaultTriggerElm = defaultSlot || h2("span", {
        "class": "tiny-dropdown__title"
      }, [title]);
      triggerElm = border ? h2("tiny-button", {
        "ref": "trigger",
        "attrs": {
          "round": round,
          "disabled": disabled,
          "reset-time": 0
        },
        "class": (state.visible ? "is-expand" : "") + (showIcon ? " is-show-icon" : "")
      }, [defaultTriggerElm, suffixInner]) : h2("span", {
        "ref": "trigger",
        "class": "is-text" + (state.visible ? " is-expand" : " is-hide") + (disabled ? " is-disabled" : "") + " " + triggerClass
      }, [defaultTriggerElm, suffixInner]);
    }
    var defaulMenuElm = h2("tiny-dropdown-menu", {
      "attrs": {
        "options": menuOptions.options,
        "text-field": menuOptions.textField || menuOptions["text-field"],
        "popper-class": menuOptions.popperClass || menuOptions["popper-class"],
        "placement": menuOptions.placement
      }
    });
    var menuElm = disabled ? null : slots.dropdown && slots.dropdown() || defaulMenuElm;
    return h2("div", {
      "class": "tiny-dropdown",
      "directives": [{
        name: "clickoutside",
        value: clickOutside
      }],
      "attrs": {
        "aria-disabled": disabled
      }
    }, [triggerElm, menuElm]);
  }
});
var __vue2_render, __vue2_staticRenderFns;
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
